import {SendSupportEmail} from "platformed-client/types";
import {platformedClient} from ".";

export async function send(sendEmail: SendSupportEmail) {
  return await platformedClient.internalRequest("post", "/region/{region}/api/support_emails/send", {
    path: {},
    body: sendEmail,
  });
}
